import { Size, DropZonePinComponent, Vector } from '../../models';
import { emptyDocument, stringToLeanProsemirror } from '../../tip-tap';
import { newBox, newSize } from '../geometry';
import { defaultOrder } from '../order';
import { randomId } from '../random-id';
import { initialPinComponentPosition } from './pin-component';

export type DropZonePinComponentSettingsProps = Omit<DropZonePinComponent['settings'], 'textFill'> & {
  textFill: string;
};

export const minimumDropZoneComponentSize = newSize(50, 50);

type DropZonePinComponentProps = {
  position?: Vector;
  size?: Size;
  order?: string;
  settings?: Partial<DropZonePinComponentSettingsProps>;
};

export function newDropZonePinComponent({
  position = initialPinComponentPosition,
  size = newSize(175, 175),
  order = defaultOrder,
  settings = {},
}: DropZonePinComponentProps): DropZonePinComponent {
  if (size.width < minimumDropZoneComponentSize.width || size.height < minimumDropZoneComponentSize.height) {
    throw new Error(
      `Drop Zone component size ${sizeToString(size)} is too small; ` +
        `need at least ${sizeToString(minimumDropZoneComponentSize)}`
    );
  }

  return {
    type: 'DROP_ZONE',
    id: randomId(),
    settings: {
      ...settings,
      textFill: settings.textFill ? stringToLeanProsemirror(settings.textFill) : emptyDocument(),
    },
    layout: newBox(position, size, 0),
    order,
  };
}

function sizeToString(size: Size): string {
  return `(${size.width}, ${size.height})`;
}
